import { IGatsbyImageData } from "gatsby-plugin-image";
import Marquee from "react-fast-marquee";
import styled from "styled-components";
import EditorialBlockVideo from "./plp/EditorialBlockVideo";
import EditorialBlocks from "./plp/EditorialBlocks";

const SocialMarqueeWrapper = styled.div`
  width: 100vw;
  margin-left: -24px;
  margin-right: -24px;

  @media (min-width: 933px) {
    margin-left: -48px;
    margin-right: -48px;
  }
`;

const SocialMarqueeItem = styled.div`
  width: 50vw;
  aspect-ratio: 84 / 149;
  margin-right: var(--spacing-1);
  overflow: hidden;

  @media (min-width: 933px) {
    width: 20vw;
  }
`;

export type Media = {
  captions?: any;
  description?: {
    description: string;
  };
  stream?: {
    videoUpload: {
      playbackId: string;
    };
  };
  title?: string;
  videoLength?: number;
  alt?: string;
  image?: {
    gatsbyImageData: IGatsbyImageData;
  };
};

type MediaPropTypes = {
  media: Media[];
};

const SocialMarquee = ({ media }: MediaPropTypes) => {
  return (
    <SocialMarqueeWrapper>
      <Marquee pauseOnHover>
        {media?.map((content: Media, index) => {
          const isVideo = !!content.stream;

          if (isVideo) {
            return (
              <SocialMarqueeItem key={`social-marquee` + index}>
                <EditorialBlockVideo
                  item={{
                    content: {
                      videoContent: content,
                    },
                    size: "small",
                  }}
                />
              </SocialMarqueeItem>
            );
          }

          if (content.image) {
            return (
              <SocialMarqueeItem key={`social-marquee` + index}>
                <EditorialBlocks
                  item={{
                    content: {
                      backgroundImage: {
                        ...content.image,
                        description: content.alt || "",
                      },
                    },
                  }}
                />
              </SocialMarqueeItem>
            );
          }

          return null;
        })}
      </Marquee>
    </SocialMarqueeWrapper>
  );
};

export default SocialMarquee;
